import { gql } from "../__generated__/gql";

gql(`
    fragment AssetFields on Asset {
        id
        status
        url
        error
    }
`);

export const GET_ASSET = gql(`
    query getAsset($assetId: ID!) {
        getAsset(assetId: $assetId) {
            ...AssetFields
        }
    }
`);
